import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
} from '@material-ui/core';
import { deleteInvoice } from '../../actions/invoiceActions';

const DeleteInvoiceDialog = ({ invoiceId, invoiceNumber, onClose, onDeleted, openSnackbar }) => {
  const dispatch = useDispatch();
  const [deleteLinkedOrder, setDeleteLinkedOrder] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setDeleteLinkedOrder(false);
    setError('');
  }, [invoiceId]);

  const handleConfirm = async () => {
    if (!invoiceId || deleting) return;
    setDeleting(true);
    setError('');
    try {
      await dispatch(deleteInvoice(invoiceId, openSnackbar, { deleteOrder: deleteLinkedOrder }));
    } catch (requestError) {
      setError(requestError?.response?.data?.message || 'Could not finish deleting. Please try again.');
      setDeleting(false);
      return;
    }
    setDeleting(false);
    onClose();
    onDeleted?.();
  };

  return (
    <Dialog
      open={Boolean(invoiceId)}
      onClose={deleting ? undefined : onClose}
      aria-labelledby="delete-invoice-title"
      aria-describedby="delete-invoice-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="delete-invoice-title">{invoiceNumber ? `Delete invoice #${invoiceNumber}?` : 'Delete invoice?'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-invoice-description">
          This invoice will move to Recently Deleted. Would you also like to delete its linked order?
        </DialogContentText>
        <FormControlLabel
          control={(
            <Checkbox
              checked={deleteLinkedOrder}
              onChange={(event) => setDeleteLinkedOrder(event.target.checked)}
              disabled={deleting}
              color="primary"
            />
          )}
          label="Also delete the linked order, if one exists"
        />
        <DialogContentText>
          {deleteLinkedOrder
            ? 'The invoice and linked order can each be restored from Recently Deleted.'
            : 'The order will be kept. You can restore the invoice from Recently Deleted.'}
        </DialogContentText>
        {error && <DialogContentText role="alert" color="error">{error}</DialogContentText>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={deleting} color="primary" autoFocus>
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={deleting} color="secondary" variant="contained">
          {deleting ? 'Deleting…' : deleteLinkedOrder ? 'Delete both' : 'Delete invoice'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteInvoiceDialog;
